import { Shell } from "@/components/layout/Shell";
import { Link } from "wouter";
import { useSeo } from "@/hooks/use-seo";

export default function NotFound() {
  useSeo({
    title: "Page not found | Mychromamind",
    description: "This page could not be found.",
    path: "/404",
    noindex: true,
  });

  return (
    <Shell>
      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
        <h1 className="text-6xl font-serif text-muted mb-4">404</h1>
        <p className="text-xl text-muted-foreground mb-8">This space does not exist.</p>
        <Link href="/" className="px-6 py-3 rounded-full border border-border hover:bg-secondary/5 transition-colors font-medium text-sm">
          Return to beginning
        </Link>
      </div>
    </Shell>
  );
}
